import React from 'react';
import { Redirect } from 'react-router';
import { FormattedMessage } from 'react-intl';

interface Props {
  isLoading: boolean;
  hasLoadedOptions: boolean;
}

export const LoadOptionsView = (props: Props) => {
  const {
    isLoading,
    hasLoadedOptions,
  } = props;

  // Error loading options from the server
  if (!isLoading && hasLoadedOptions === false) {
    return (
      <div className="LoadOptions">
        <h2 className="LoadOptions-error">
          <FormattedMessage id="CANNOT_LOAD_OPTIONS" />
        </h2>
      </div>
    );
  }

  if (!isLoading) {
    return (
      <Redirect to="/sign-up/work-it-out" />
    );
  }

  return (
    <div className="LoadOptions">
      <div className="LoadOptions-Spinner" role="progressbar" aria-label="Loading" aria-busy="true" aria-live="assertive">
        <div className="Spinner Spinner--large">
          <i /><i /><i /><i /><i /><i />
        </div>

        <FormattedMessage tagName="h2" id="LOADING" />
      </div>
    </div>
  );
};
